import { Hidden as NbHidden } from 'native-base';

import { addWithConfig } from '../../utils';

export const Hidden = NbHidden;

export default addWithConfig(Hidden);
